import { defineMessages, type MessageValue } from 'react-intl';

export const giftCardsScreenCategoriesGridMessages = defineMessages<{
  readonly gridItemA11yLabel: { readonly gift_card: MessageValue };
}>({
  gridItemA11yLabel: {
    defaultMessage: 'Select "{gift_card}" gift card',
    description: 'Gift Cards | Grid item accessibility label',
  },
});
